// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__T3GAw","location":"Header_location__2og6u"};